import {FC} from "react";
import { useDonateBonusContext } from "./context";
import { Text } from '@constructor/components';

const DonateBonusName: FC = (props) => {
    const bonus = useDonateBonusContext();
    if(!bonus){
        return null;
    }

    const replaces = {
        bonus_name: bonus.name
    }

    return (
        <Text text={bonus.name} {...props} replaces={replaces} />
    )
}

export default DonateBonusName;